<template>
    <vx-table-row>
        <vx-table-row-title class="xl:col-span-2! break-words">
            {{ model.id === userId ? 'You' : model.name }}
            <div class="text-sm text-slate-500 font-normal mt-1">{{ model.email }}</div>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Role: </template>
            {{ GROUP_USER_ROLES[model.role] || '-' }}
        </vx-table-row-item>

        <vx-table-row-buttons v-if="onCorporate() || ['admin'].includes(roleOnCurrentGroup)">
            <vx-button
                @click="confirmModal = true"
                data-test="delete"
                color="muted"
                outline>
                <font-awesome-icon widthAuto :icon="faCircleMinus" />
            </vx-button>

            <vx-button
                @click="emit('edit')"
                data-test="edit"
                color="muted"
                outline>
                Edit <font-awesome-icon widthAuto :icon="faFilePen" />
            </vx-button>
        </vx-table-row-buttons>

        <warning-modal v-model:visible="confirmModal"
            confirmText="Yes, remove user"
            message="The user will immediately lose access to this group."
            @confirm="deleteUser">
        </warning-modal>
    </vx-table-row>
</template>

<script setup>
import {
    faCircleMinus,
    faFilePen,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxButton,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import { useCurrentGroup } from "~/composables/useCurrentGroup";
import { useToasted } from '~/composables/useToasted';
import { GROUP_USER_ROLES } from "~/constants/roles";
import { groupUsersClient } from "~/services";
import WarningModal from '~/components/modals/WarningModal.vue';
import { ref } from 'vue';
import { catchRequestError } from "~/utils/request";

const toasted = useToasted();
const userId = Spark.state.user.id;
const { onCorporate, roleOnCurrentGroup } = useCurrentGroup();

const model = defineModel({
    type: Object,
    required: true,
});

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['deleted', 'edit']);
const confirmModal = ref(false);

const deleteUser = async () => {
    try {
        await groupUsersClient.deleteGroupUser(props.teamId, props.groupId, model.value.id);
        toasted.success(`${model.value.name || model.value.email} removed from Group`)
        emit('deleted');
        confirmModal.value = false;
    } catch (e) {
        console.error(e);
        toasted.error(catchRequestError(e));
    }
};

</script>
